import React from "react";
import { useSelector } from "react-redux";

import { userSetupQuestionsSelector } from "src/store/system/selector";
import { SetupQuestions } from "src/pages/GetStarted/Onboarding/SetupQuestions";
import PersonalizeSetupLoading from "src/pages/Onboarding/PersonalizeSetupLoading";

export interface OnboardingContentProps {
  onClose: () => void;
}

function OnboardingContent({ onClose }: OnboardingContentProps) {
  const setupQuestions = useSelector(userSetupQuestionsSelector);

  if (!setupQuestions) return <SetupQuestions onClose={onClose} />;
  else {
    return <PersonalizeSetupLoading />;
  }
}

export default OnboardingContent;
